const APP_NAMES = {
    FASTSTART: 'Faststart',
    POR: 'POR',
    PULSE_FLOW: 'PulseFlow',
    PULSE_LIVE: 'PulseLive',
    PULSE_PLANNING: 'PulsePlanning',
    PULSE_REPORTING: 'PulseReporting',
    WATCHTOWER: 'WatchTower',
    PULSE_GOLDEN_EYE: 'PulseGoldenEye',
    PACKAGEFLIX: 'PackageFlix',
};
/**
 * Returns a domain record mapping based on expected Pulse endpoint.
 * Note*: If an endpoint is not in this mapping, our domain will default to 'dev'.
 */
const DOMAINS = {
    'planning.beta.pulse.ats.amazon.dev': 'beta',
    'planning.pulse.ats.amazon.dev': 'prod',
    'reporting.beta.pulse.ats.amazon.dev': 'beta',
    'reporting.pulse.ats.amazon.dev': 'prod',
    'flow.beta.pulse.ats.amazon.dev': 'beta',
    'flow.pulse.ats.amazon.dev': 'prod',
    'na.planofrecord.nasctech.amazon.dev': 'prod',
    'beta.planofrecord.nasctech.amazon.dev': 'beta',
    'beta.watchtower.ats.amazon.dev': 'beta',
    'na.watchtower.ats.amazon.dev': 'prod',
    'na.goldeneye.ats.amazon.dev': 'prod',
    'beta.goldeneye.ats.amazon.dev': 'beta',
    'packageflix.huron.ats.amazon.dev': 'prod',
    'packageflixbeta.huron.ats.amazon.dev': 'beta',
};
/**
 * Returns an app name based on the hostName from window object.
 */
const getAppName = () => {
    const domainSplit = new Set(window.location.hostname.split('.'));
    if (domainSplit.has('planning'))
        return APP_NAMES.PULSE_PLANNING;
    if (domainSplit.has('reporting'))
        return APP_NAMES.PULSE_REPORTING;
    if (domainSplit.has('live'))
        return APP_NAMES.PULSE_LIVE;
    if (domainSplit.has('flow'))
        return APP_NAMES.PULSE_FLOW;
    if (domainSplit.has('planofrecord'))
        return APP_NAMES.POR;
    if (domainSplit.has('watchtower'))
        return APP_NAMES.WATCHTOWER;
    if (domainSplit.has('goldeneye'))
        return APP_NAMES.PULSE_GOLDEN_EYE;
    if (domainSplit.has('packageflix'))
        return APP_NAMES.PACKAGEFLIX;
    return APP_NAMES.PULSE_PLANNING; // This is for default AppName used in dev server and in cases where the App details record
    // is not available in APP_NAMES map. As this function is being used to build KatalMetricsContext
    // with site, it can't be empty therefore returning PULSE_PLANNING as the default app name.
};
/**
 * Returns a domain name beta/prod/dev based on the hostName and using the domain record map.
 */
const getSushiDomain = () => {
    const domain = DOMAINS[window.location.hostname] || 'dev';
    return domain;
};
const appName = getAppName();
const katalDomain = getSushiDomain();
export { appName, katalDomain };
//# sourceMappingURL=DomainUtils.js.map